import icon_compass from '@/assets/images/rightNavCtrl/icon_compass.png'
import navigation_outline from '@/assets/images/rightNavCtrl/navigation-outline.png'
import shadow_on from '@/assets/images/rightNavCtrl/shadow_on.png'
import shadow_off from '@/assets/images/rightNavCtrl/shadow_off.png'
import icon_lod_on from '@/assets/images/rightNavCtrl/icon_lod_on.png'
import icon_lod_off from '@/assets/images/rightNavCtrl/icon_lod_off.png'
import icon_model_off from '@/assets/images/rightNavCtrl/icon_model_off.png'
import icon_model_on from '@/assets/images/rightNavCtrl/icon_model_on.png'
import icon_measure_off from '@/assets/images/rightNavCtrl/icon_measure_off.png'
import icon_measure_on from '@/assets/images/rightNavCtrl/icon_measure_on.png'
import icon_analyze_off from '@/assets/images/rightNavCtrl/icon_analyze_off.png'
import icon_analyze_on from '@/assets/images/rightNavCtrl/icon_analyze_on.png'
import icon_close from '@/assets/images/rightNavCtrl/icon_close.png'
import icon_screen from '@/assets/images/rightNavCtrl/icon_screen.png'
import icon_plus from '@/assets/images/rightNavCtrl/icon_plus.png'
import icon_minus from '@/assets/images/rightNavCtrl/icon_minus.png'
import icon_an1_off from '@/assets/images/rightNavCtrl/icon_an1_off.png'
import icon_an1_on from '@/assets/images/rightNavCtrl/icon_an1_on.png'
import icon_an2_off from '@/assets/images/rightNavCtrl/icon_an2_off.png'
import icon_an2_on from '@/assets/images/rightNavCtrl/icon_an2_on.png'
import icon_an3_off from '@/assets/images/rightNavCtrl/icon_an3_off.png'
import icon_an3_on from '@/assets/images/rightNavCtrl/icon_an3_on.png'
import icon_an4_off from '@/assets/images/rightNavCtrl/icon_an4_off.png'
import icon_an4_on from '@/assets/images/rightNavCtrl/icon_an4_on.png'
import icon_an5_off from '@/assets/images/rightNavCtrl/icon_an5_off.png'
import icon_an5_on from '@/assets/images/rightNavCtrl/icon_an5_on.png'
import icon_an6_off from '@/assets/images/rightNavCtrl/icon_an6_off.png'
import icon_an6_on from '@/assets/images/rightNavCtrl/icon_an6_on.png'
import icon_me1_off from '@/assets/images/rightNavCtrl/icon_me1_off.png'
import icon_me1_on from '@/assets/images/rightNavCtrl/icon_me1_on.png'
import icon_me2_off from '@/assets/images/rightNavCtrl/icon_me2_off.png'
import icon_me2_on from '@/assets/images/rightNavCtrl/icon_me2_on.png'
import icon_me3_off from '@/assets/images/rightNavCtrl/icon_me3_off.png'
import icon_me3_on from '@/assets/images/rightNavCtrl/icon_me3_on.png'
import icon_me4_off from '@/assets/images/rightNavCtrl/icon_me4_off.png'
import icon_me4_on from '@/assets/images/rightNavCtrl/icon_me4_on.png'
import icon_me5_off from '@/assets/images/rightNavCtrl/icon_me5_off.png'
import icon_me5_on from '@/assets/images/rightNavCtrl/icon_me5_on.png'
import icon_pen from '@/assets/images/rightNavCtrl/icon-pen.png'
import icon_pen_on from '@/assets/images/rightNavCtrl/icon-pen-on.png'
import icon_area from '@/assets/images/rightNavCtrl/icon-area.png'
import icon_area_on from '@/assets/images/rightNavCtrl/icon-area-on.png'
import icon_building from '@/assets/images/rightNavCtrl/icon-building.png'
import icon_building_on from '@/assets/images/rightNavCtrl/icon-building-on.png'

const AN1 = 'an1'
const AN2 = 'an2'
const AN3 = 'an3'
const AN4 = 'an4'
const AN5 = 'an5'
const AN6 = 'an6'

const ME1 = 'me1'
const ME2 = 'me2'
const ME3 = 'me3'
const ME4 = 'me4'
const ME5 = 'me5'

const AN1_MODAL_TITLE = '경사도 분석'
const AN2_MODAL_TITLE = '경사방향 분석'
const AN3_MODAL_TITLE = '가시권 분석'
const AN4_MODAL_TITLE = '스카이라인 분석'
const AN5_MODAL_TITLE = '조망 분석'
const AN6_MODAL_TITLE = '음영 분석'

const ME4_MODAL_TITLE = '부피 측정'
const AN1_MODAL_RESULT_TITLE = '경사도 분석 결과'

const MODAL_WIDTH_AN1 = 400
const MODAL_WIDTH350 = 350
const MODAL_WIDTH400 = 400
const MODAL_WIDTH560 = 560
const MODAL_WIDTH600 = 600

const areaList = [
  {
    label: '고창군',
    value: '45790',
    sggCd: '35570',
  },
  {
    label: '군산시',
    value: '45130',
    sggCd: '35020',
  },
  {
    label: '김제시',
    value: '45210',
    sggCd: '35060',
  },
  {
    label: '남원시',
    value: '45190',
    sggCd: '35050',
  },
  {
    label: '무주군',
    value: '45730',
    sggCd: '35530',
  },
  {
    label: '부안군',
    value: '45800',
    sggCd: '35580',
  },
  {
    label: '순창군',
    value: '45770',
    sggCd: '35560',
  },
  {
    label: '완주군',
    value: '45710',
    sggCd: '35510',
  },
  {
    label: '익산시',
    value: '45140',
    sggCd: '35030',
  },
  {
    label: '임실군',
    value: '45750',
    sggCd: '35550',
  },
  {
    label: '장수군',
    value: '45740',
    sggCd: '35540',
  },
  {
    label: '전주시 덕진구',
    value: '45113',
    sggCd: '35012',
  },
  {
    label: '전주시 완산구',
    value: '45111',
    sggCd: '35011',
  },
  {
    label: '정읍시',
    value: '45180',
    sggCd: '35040',
  },
  {
    label: '진안군',
    value: '45720',
    sggCd: '35520',
  },
]

// contentArr2 - contentArr7 Field to be retrieved from the API
//  avgAge      평균나이(세)
// agedChildIdx      노령화지수(명/1백명)
// totFamily      총 가구수
// totPpltn      총 인구수
// fPer      여자 비율
// mPer      남자 비율
// fPpl      여자 인구
// mPpl      남자 인구
// residPpltnPer      거주인구비율
// jobPpltnPer      직장인구비율
// onePersonFamilyPer      1인가구비율
// sixtyFiveMorePpltnPer      65세이상인구비율
// twentyPpltnPer      20대비율

const contentArr2 = [
  [{ key: '평균나이(세)', value: '' }, { key: '노령화지수(명/1백명)', value: '' }],
  [{ key: '총 가구수', value: '' }, { key: '총 인구수', value: '' }],
]

const contentArr3 = [
  [{ key: '여자 비율', value: '' }, { key: '남자 비율', value: '' }],
  [{ key: '여자 인구', value: '' }, { key: '남자 인구', value: '' }],
  [{ key: '거주인구비율', value: '' }],
  [{ key: '직장인구비율', value: '' }],
  [{ key: '1인가구비율', value: '' }],
  [{ key: '65세 이상인구비율', value: '' }],
  [{ key: '20대 인구비율', value: '' }],
]

const contentArr4 = [
  [{ key: '사업체 수', value: '' }],
]

const contentArr5 = [
  [{ title: '', name: '', value: '' }],
  [{ title: '', name: '', value: '' }],
  [{ title: '', name: '', value: '' }],
]

const contentArr6 = [
  [{ title: '', name: '', value: '' }],
  [{ title: '', name: '', value: '' }],
  [{ title: '', name: '', value: '' }],
]

const contentArr7 = [
  [{ title: '', name: '', value: '' }],
  [{ title: '', name: '', value: '' }],
  [{ title: '', name: '', value: '' }],
]

const CAMERA_HEIGHT = 400000
const POLYGON_HIDE_HEIGHT = 30000

// 고창군
// 군산시
// 김제시
// 남원시
// 무주군
// 부안군
// 순창군
// 완주군
// 익산시
// 임실군
// 장수군
// 전주시
// 정읍시
// 진안군
const addressArr = [
  { label: '고창군', value: 'address', checked: false, wmsLayerName: 'lx:nd-road1' },
  { label: '군산시', value: 'address2', checked: false, wmsLayerName: 'lx:nd-road2' },
  { label: '김제시', value: 'address3', checked: false, wmsLayerName: 'lx:nd-road3' },
  { label: '남원시', value: 'address4', checked: false, wmsLayerName: 'lx:nd-road4' },
  { label: '무주군', value: 'address5', checked: false, wmsLayerName: 'lx:nd-road5' },
  { label: '부안군', value: 'address6', checked: false, wmsLayerName: 'lx:nd-road6' },
  { label: '순창군', value: 'address7', checked: false, wmsLayerName: 'lx:nd-road7' },
  { label: '완주군', value: 'address8', checked: false, wmsLayerName: 'lx:nd-road8' },
  { label: '익산시', value: 'address9', checked: false, wmsLayerName: 'lx:nd-road9' },
  { label: '임실군', value: 'address10', checked: false, wmsLayerName: 'lx:nd-road10' },
  { label: '장수군', value: 'address11', checked: false, wmsLayerName: 'lx:nd-road11' },
  { label: '전주시', value: 'address12', checked: false, wmsLayerName: 'lx:nd-road12' },
  { label: '정읍시', value: 'address13', checked: false, wmsLayerName: 'lx:nd-road13' },
  { label: '진안군', value: 'address14', checked: false, wmsLayerName: 'lx:nd-road14' },
]

const landRatioArr = [
  { name: '논', value: ['1110', '1120'], area: 0, ratio: '' },
  { name: '밭', value: ['1210', '1220'], area: 0, ratio: '' },
  { name: '초지', value: ['2110', '2120'], area: 0, ratio: '' },
  { name: '입목지', value: ['2210', '2220', '2230'], area: 0, ratio: '' },
  { name: '임지-기타', value: ['2310', '2320', '2330', '2340'], area: 0, ratio: '' },
  { name: '주거지 및 상업지', value: ['3110', '3120', '3130', '3140'], area: 0, ratio: '' },
  { name: '교통시설', value: ['3210', '3220', '3230', '3240'], area: 0, ratio: '' },
  { name: '공업지', value: ['3310', '3320'], area: 0, ratio: '' },
  { name: '공공시설물', value: ['3410', '3420', '3430', '3440'], area: 0, ratio: '' },
  { name: '기타시설', value: ['3510', '3520', '3530', '3540', '3550'], area: 0, ratio: '' },
  { name: '습지', value: ['4110', '4120'], area: 0, ratio: '' },
  { name: '하천', value: ['4210'], area: 0, ratio: '' },
  { name: '호소', value: ['4310', '4320'], area: 0, ratio: '' },
  { name: '수계-기타', value: ['4410'], area: 0, ratio: '' },
]

export {
  icon_compass,
  navigation_outline,
  shadow_on,
  shadow_off,
  icon_lod_on,
  icon_lod_off,
  icon_model_off,
  icon_model_on,
  icon_measure_off,
  icon_measure_on,
  icon_analyze_off,
  icon_analyze_on,
  icon_close,
  icon_screen,
  icon_plus,
  icon_minus,
  icon_an1_off,
  icon_an1_on,
  icon_an2_off,
  icon_an2_on,
  icon_an3_off,
  icon_an3_on,
  icon_an4_off,
  icon_an4_on,
  icon_an5_off,
  icon_an5_on,
  icon_an6_off,
  icon_an6_on,
  icon_me1_off,
  icon_me1_on,
  icon_me2_off,
  icon_me2_on,
  icon_me3_off,
  icon_me3_on,
  icon_me4_off,
  icon_me4_on,
  icon_me5_off,
  icon_me5_on,
  AN1,
  AN2,
  AN3,
  AN4,
  AN5,
  AN6,
  ME1,
  ME2,
  ME3,
  ME4,
  ME5,
  AN1_MODAL_TITLE,
  AN2_MODAL_TITLE,
  AN3_MODAL_TITLE,
  AN4_MODAL_TITLE,
  AN5_MODAL_TITLE,
  MODAL_WIDTH560,
  MODAL_WIDTH400,
  AN6_MODAL_TITLE,
  MODAL_WIDTH350,
  ME4_MODAL_TITLE,
  MODAL_WIDTH600,
  AN1_MODAL_RESULT_TITLE,
  MODAL_WIDTH_AN1,
  icon_pen,
  icon_pen_on,
  icon_area,
  icon_area_on,
  icon_building,
  icon_building_on,
  areaList,
  contentArr2,
  contentArr3,
  contentArr4,
  contentArr5,
  contentArr6,
  contentArr7,
  CAMERA_HEIGHT,
  POLYGON_HIDE_HEIGHT,
  addressArr,
  landRatioArr,
}
